import config from '@/config'

export default {
  data () {
    return {
      BRANDS: config.BRANDS
    }
  },
  methods: {
    webUrl (brandCode) {
      return config.WEB_URL(brandCode)
    }
  }
}
